"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdministratorRole = void 0;
var AdministratorRole;
(function (AdministratorRole) {
    AdministratorRole["JIRA"] = "jira";
})(AdministratorRole || (exports.AdministratorRole = AdministratorRole = {}));
//# sourceMappingURL=AdministratorRole.js.map